import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['downPaymentInput', 'residualValueInput', 'payoffAmountInput']

  connect() {
    this.validateInfo()
    this.downPaymentInput.addEventListener('blur', _e => { this.updateFinanceAmount()})
    this.residualValueInput.addEventListener('blur', _e => { this.updateFinanceAmount()})
  }

  validateInfo() {
    const residual = this.residualValueInput.value || 0
    const down = this.downPaymentInput.value || 0
    if (!(residual + down <= 0)) return

    alert('Se detectaron posibles inconsistencias en la información extraída de Odoo, por favor verificar')
    this.downPaymentInput.value = ''
    this.residualValueInput.value = ''
    this.payoffAmountInput.value = ''
  }

  updateFinanceAmount() {
    const residualValue = parseFloat(this.residualValueInput.value) || 0
    const downPayment = parseFloat(this.downPaymentInput.value) || 0
    const newFinanceAmount = residualValue - downPayment
    this.payoffAmountInput.value = newFinanceAmount
  }

  get downPaymentInput() { return this.downPaymentInputTarget }

  get initialPaymentInput() { return document.getElementById('initialPaymentInput') }

  get residualValueInput() { return this.residualValueInputTarget }

  get payoffAmountInput() { return this.payoffAmountInputTarget }
}
